export default __webpack_public_path__ + "static/media/dollarSymbol.b08a2a4b.svg";